/**
 * Paths of the routes that must be reachable without a login.
 *
 * ⚠️ AGB 17 cites the cancellation page as one of the ways to cancel, and the
 * withdrawal instructions name the withdrawal page, so these paths are part
 * of legal texts and must not move without those texts moving too.
 * German paths on purpose; the pages themselves are bilingual.
 */

/** Step one: the "Verträge hier kündigen" button (§ 312k Abs. 2 Satz 1). */
export const CANCELLATION_PATH = "/kuendigung";

/** Step two: the confirmation page (§ 312k Abs. 2 Satz 3). */
export const CANCELLATION_CONFIRM_PATH = "/kuendigung/bestaetigen";

/** The Art. 16 DSA notice form and the point of contact. */
export const DSA_PATH = "/dsa";

/**
 * Step one of the withdrawal function of § 356a BGB: the "Vertrag widerrufen"
 * button and the form behind it.
 *
 * ⚠️ The withdrawal instructions name this page as the online way to withdraw,
 * so it must not move without them.
 */
export const WITHDRAWAL_PATH = "/widerruf";

/** Step two: the "Widerruf bestätigen" button (§ 356a Abs. 1 BGB). */
export const WITHDRAWAL_CONFIRM_PATH = "/widerruf/bestaetigen";
